import * as React from 'react';
import { IATooltip } from '../../../tooltip/Tooltip';
import { IAIcon } from '../../../icon/Icon';

export interface INavigatorTargetingTooltipProps {
  targetingInfo: string;
  highlightColor: string;
}

export class NavigatorTargetingTooltip extends React.Component<INavigatorTargetingTooltipProps> {
  render() {
    return (
      <>
        {this.props.targetingInfo &&
          <div
            style={{
              position: "absolute",
              right: 0,
              top: 0,
            }}
          >
            <IATooltip
              type="bubble"
              content={"tooltip"}
              componentContent={<div
                dangerouslySetInnerHTML={{
                  __html: this.props.targetingInfo
                }}
              />}
              borderRadius={5}
              popupMaxHeight={500}
              showBelow
            >
              <div
                style={{
                  backgroundColor: "white",
                  height: 15,
                  width: 15,
                  borderRadius: 15,
                  zIndex: 2,
                  position: "relative"
                }}
              >
                <IAIcon
                  color={this.props.highlightColor}
                  size={13}
                  url="https://intraactivestorage.blob.core.windows.net/cdn/icons/People%20Checkmark/SVG/ic_fluent_people_checkmark_24_regular.svg"
                  svgStyle={{
                    marginBottom: 3,
                    marginLeft: 1
                  }}
                />
              </div>
            </IATooltip>
          </div>
        }
      </>
    )
  }
}